import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Edition } from 'src/app/core/models/api/edition.model';
import { Campus } from 'src/app/core/models/api/campus.model';
import { CampusService } from 'src/app/core/services/api/campus.service';
import { CampusResourceService } from 'src/app/core/services/api/campus-resource.service';
import { EditionResourceService } from 'src/app/core/services/api/edition-resource.service';

@Component({
    selector: 'app-header-menu',
    templateUrl: './header-menu.component.html',
    styleUrls: ['./header-menu.component.scss']
})
export class HeaderMenuComponent implements OnInit {

    public campus : Campus;

    public logoCampus: string;

    public urlHome          : string;
    public urlCampus        : string;
    public urlGoals         : string;
    public urlProfessorate  : string;
    public urlContact       : string;
    public urlEnrollments   : string;

    public urlCourses       : string;
    public urlFaq           : string;
    public urlSchedulePrices: string;
    
    constructor(
        private campusService: CampusService,
        private campusResourceService: CampusResourceService,
        private editionResourceService: EditionResourceService) { }

    ngOnInit() { 

        this.campus = this.campusService.campusActive;
        this.getCampusResources();

    }

    getCampusResources() {

        this.logoCampus      = this.campusResourceService.findResource(this.campus.resources, 'logo-campus');
        this.urlCampus       = this.campusResourceService.findResource(this.campus.resources, 'url-campus');
        this.urlGoals        = this.campusResourceService.findResource(this.campus.resources, 'url-goals');
        this.urlProfessorate = this.campusResourceService.findResource(this.campus.resources, 'url-professorate');
        this.urlContact      = this.campusResourceService.findResource(this.campus.resources, 'url-contact');
        this.urlEnrollments  = this.campusResourceService.findResource(this.campus.resources, 'url-enrollments');
        this.urlHome         = this.campusResourceService.findResource(this.campus.resources, 'url-home');

    }

    checkEnrollmentsOpen() : boolean {

        return this.campus.editions.filter(e => e.areEnrollmentsOpen === true).length > 0;

    }

    getEditionIcon(edition: Edition) : string {

        return this.editionResourceService.findResource(edition.resources, 'material-icon-name');

    }

    getEditionLinks(edition : Edition) {

        var editionBasePath = edition.editionId.toString() + '/';
        
        var urlCourseResource         = this.editionResourceService.findResource(edition.resources, 'url-courses');
        var urlFaqResource            = this.editionResourceService.findResource(edition.resources, 'url-faq');
        var urlSchedulePricesResource = this.editionResourceService.findResource(edition.resources, 'url-schedule-and-prices');

        this.urlCourses        = urlCourseResource ? editionBasePath + urlCourseResource : null;
        this.urlFaq            = urlFaqResource ? editionBasePath + urlFaqResource : null;
        this.urlSchedulePrices = urlSchedulePricesResource ? editionBasePath + urlSchedulePricesResource : null;
        
    }

    goToEnrollmentsPage() {

        window.open(this.urlEnrollments);

    }

}
